
import React from 'react';
import { ServicePackage, Language, SocialPlatform } from '../types';
import { TRANSLATIONS } from '../translations';
import { Twitter, Youtube, Instagram, Facebook, Tv, Music, BookHeart, Globe, Check, ArrowRight, Edit3, Trash2 } from 'lucide-react';

interface ServiceCardProps {
  pkg: ServicePackage;
  language: Language;
  onBook: (pkg: ServicePackage) => void;
  isOwner: boolean;
  onEdit?: (pkg: ServicePackage) => void;
  onDelete?: (pkg: ServicePackage) => void;
}

const getPlatformIcon = (platform: SocialPlatform) => {
    switch (platform) {
      case SocialPlatform.TWITTER: return <Twitter size={16} className="text-blue-400" />;
      case SocialPlatform.YOUTUBE: return <Youtube size={16} className="text-red-500" />;
      case SocialPlatform.INSTAGRAM: return <Instagram size={16} className="text-pink-500" />;
      case SocialPlatform.FACEBOOK: return <Facebook size={16} className="text-blue-600" />;
      case SocialPlatform.TIKTOK: return <Music size={16} className="text-black dark:text-white" />;
      case SocialPlatform.BILIBILI: return <Tv size={16} className="text-blue-300" />;
      case SocialPlatform.RED_BOOK: return <BookHeart size={16} className="text-red-400" />;
      default: return <Globe size={16} />;
    }
  };

export const ServiceCard: React.FC<ServiceCardProps> = ({ pkg, language, onBook, isOwner, onEdit, onDelete }) => {
  const t = TRANSLATIONS[language];

  return (
    <div className="bg-slate-900 border border-slate-700 rounded-xl p-5 hover:border-indigo-500/50 transition-all flex flex-col h-full group relative">
      <div className="flex justify-between items-start mb-4">
        <div className="bg-slate-800 p-2 rounded-lg">
            {getPlatformIcon(pkg.platform)}
        </div>
        <div className="text-right">
            <span className="text-xl font-bold text-white">${pkg.price}</span>
            <span className="text-xs text-slate-500 block">USDT</span>
        </div>
      </div>

      <h4 className="text-lg font-bold text-white mb-2 group-hover:text-indigo-400 transition-colors pr-8">{pkg.title}</h4>
      <p className="text-sm text-slate-400 mb-4 flex-1">{pkg.description}</p>

      <div className="space-y-2 mb-6">
        {pkg.features.map((feature, idx) => (
            <div key={idx} className="flex items-center gap-2 text-xs text-slate-300">
                <Check size={12} className="text-emerald-500" />
                {feature}
            </div>
        ))}
      </div>

      <div className="mt-auto pt-4 border-t border-slate-800 flex justify-between items-center">
         <span className="text-xs text-slate-500">{pkg.deliveryDays} {t.delivery}</span>
         {!isOwner ? (
             <button 
                onClick={() => onBook(pkg)}
                className="bg-slate-800 hover:bg-indigo-600 text-slate-300 hover:text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-1"
             >
                {t.bookNow} <ArrowRight size={14} />
             </button>
         ) : (
            <div className="flex gap-2">
                 <button 
                    onClick={() => onEdit && onEdit(pkg)}
                    className="p-2 bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-white rounded-lg transition-colors"
                 >
                    <Edit3 size={14} />
                 </button>
                 <button 
                    onClick={() => onDelete && onDelete(pkg)}
                    className="p-2 bg-slate-800 hover:bg-slate-700 text-slate-400 hover:text-rose-400 rounded-lg transition-colors"
                 >
                    <Trash2 size={14} />
                 </button>
            </div>
         )}
      </div>
    </div>
  );
};
